/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import type { ForcModelPojo } from "parog-web/components/forc/abstract/journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import IbdDiskSurveyFilledJournalEvent from "parog-web/models/ibd-disk-survey-filled-journal-event";
import type SemeiaSessionService from "parog-web/services/session";

export default class extends CrudJournalEventBaseComponent<IbdDiskSurveyFilledJournalEvent> {
  static fullComponentId = "mici/ibd-disk-survey-consult-form";
  static journalEventClass = IbdDiskSurveyFilledJournalEvent;
  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  @service declare session: SemeiaSessionService;

  get forcDisplayName(): string {
    return this.session.medic ? "Questionnaire IBD-Disk" : "Qualité de vie";
  }

  get sections(): Array<string> {
    return IbdDiskSurveyFilledJournalEvent.sections;
  }

  retrieveModel(): ForcModelPojo {
    const model = super.retrieveModel();

    this.sections.forEach(section => {
      if (!model[section]) {
        model[section] = "0";
      }
    });

    return model;
  }
}
